import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import ReactSelect from 'react-select';
import {
  SlideContent,
  ModalDescription,
  SelectGroup,
  SelectWrapper,
  Label,
  SelectContainer,
  ButtonsContainer,
  PrimaryButton,
  SecondaryButton,
} from '../shared';

const FieldSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 20px;
`;

const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #444444;
`;

const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #444444;
  flex-shrink: 0;
`;

const BulkCopySlide1 = ({
  startWeek,
  endWeek,
  startWeekOptions,
  endWeekOptions,
  onStartWeekChange,
  onEndWeekChange,
  copyNotes,
  onCopyNotesChange,
  onClose,
  onNext,
}) => {
  const isNextDisabled = !startWeek || !endWeek;

  return (
    <SlideContent>
      <ModalDescription>
        Select the start week and end week from the current selected calendar
        that you wish to copy over to other calendars. You can copy a maximum
        of 1 year (52 weeks) of planner blocks at a time. You can also select
        whether or not to copy any notes within the selected range.
      </ModalDescription>

      <SelectGroup>
        <SelectWrapper>
          <Label htmlFor='copy-start-week'>Start Week</Label>
          <SelectContainer>
            <ReactSelect
              inputId='copy-start-week'
              value={startWeek}
              onChange={onStartWeekChange}
              options={startWeekOptions}
              classNamePrefix='react-select'
              isSearchable={false}
              placeholder='Select week'
              menuPlacement='auto'
            />
          </SelectContainer>
        </SelectWrapper>

        <SelectWrapper>
          <Label htmlFor='copy-end-week'>End Week</Label>
          <SelectContainer>
            <ReactSelect
              inputId='copy-end-week'
              value={endWeek}
              onChange={onEndWeekChange}
              options={endWeekOptions}
              classNamePrefix='react-select'
              isSearchable={false}
              placeholder='Select week'
              menuPlacement='auto'
            />
          </SelectContainer>
        </SelectWrapper>
      </SelectGroup>

      <FieldSection>
        <Label as='span'>Copy Notes</Label>
        <CheckboxRow>
          <Checkbox
            type='checkbox'
            checked={copyNotes}
            onChange={(e) => onCopyNotesChange(e.target.checked)}
          />
          Copy notes within selected range
        </CheckboxRow>
      </FieldSection>

      <ButtonsContainer>
        <PrimaryButton onClick={onNext} disabled={isNextDisabled}>
          Next
        </PrimaryButton>
        <SecondaryButton onClick={onClose}>
          Cancel
        </SecondaryButton>
      </ButtonsContainer>
    </SlideContent>
  );
};

BulkCopySlide1.propTypes = {
  startWeek: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  endWeek: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  startWeekOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  endWeekOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  onStartWeekChange: PropTypes.func.isRequired,
  onEndWeekChange: PropTypes.func.isRequired,
  copyNotes: PropTypes.bool.isRequired,
  onCopyNotesChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

BulkCopySlide1.defaultProps = {
  startWeek: null,
  endWeek: null,
};

export default BulkCopySlide1;
